export default "__VITE_ASSET__CfGk3Tfn__"